import MaterialType from ".";

export const materialTypesRoutes = [
  {
    path: "/materialTypes",
    element: <MaterialType />,
  },
];
